import { BeneficiaryConfiguration } from "src/app/ui/models/domains/pbm/Benefit/beneficiary-configuration";
import { AbstractParser } from "../../parser";

export class BeneficiaryConfigurationParser extends AbstractParser<BeneficiaryConfiguration> {
  parse(payload: any): BeneficiaryConfiguration {
    const beneficiaryConfiguration = new BeneficiaryConfiguration();
    beneficiaryConfiguration.setKey(payload.Key);
    beneficiaryConfiguration.setCompanyFiscalNumber(payload.CompanyFiscalNumber);
    beneficiaryConfiguration.setAllowOrderCard(payload.AllowOrderCard);
    beneficiaryConfiguration.setOrderCardQuantity(payload.OrderCardQuantity);
    return beneficiaryConfiguration;
  }
}
